import axios from 'axios'

async function login (user) {
  return axios.post('/admin/auth/login', user)
}

async function checkAuth () {
  return axios.get('/admin/auth')
}

export default {
  login,
  checkAuth
}



// WEBPACK FOOTER //
// ./src/api/auth.js